import React from "react";
import { useIntl } from "react-intl";
import { actionModalMessages } from "../../../orchestrator.messages";

interface UrlInputProps {
  value: string;
  error?: string;
  onChange: (value: string) => void;
}

export function UrlInput({ value, error, onChange }: UrlInputProps) {
  const intl = useIntl();

  return (
    <div>
      <input
        type="url"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={intl.formatMessage(actionModalMessages.urlPlaceholder)}
        className="w-full border rounded px-3 py-2"
      />
      {error && <div className="text-red-500 text-xs mt-1">{error}</div>}
    </div>
  );
}
